var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="#"data-bind="bsTooltip: {\n				trigger: \'hover\',\n				stayOnHover: true,\n				titleSelector: _titleSelector\n				},\n				click: _.noop"> <i class="fa fa-question-circle"></i> </a><!-- HACK: `id` and `titleSelector` -_\\ --> <div style="display: none"data-bind="attr: { id: _titleId }"> <div class="padding-left-1 padding-right-1"> <p> Не нашли свой <br> населенный пункт? </p> <button type="button"class="btn btn-transparent-light btn-xs"data-dismiss="tooltip"data-bind="click: $data._openModalClick.bind($data)"> Выбрать из списка </button> </div> </div>';
}
return __p;
};
